import React from 'react';
import { Box, Icon } from '@chakra-ui/react';
import { FiClock, FiAlertCircle } from 'react-icons/fi';

/**
 * Delivery ticks, drawn the way WhatsApp draws them: one check for sent, two
 * overlapping for delivered, the same two in blue for read.
 *
 * One inline SVG in `currentColor`, so the colour is a token on the wrapper
 * and the shape never changes. `PENDING` is client-only (the optimistic
 * bubble); `PENDING_UNKNOWN` is the server's word for "Meta has not said yet".
 * `ACCEPTED` is the connection layer's acknowledgement, which WhatsApp itself
 * would already draw as a single tick.
 */
const LABEL = {
	PENDING: 'Sending',
	PENDING_UNKNOWN: 'Sending',
	ACCEPTED: 'Sent',
	SENT: 'Sent',
	DELIVERED: 'Delivered',
	READ: 'Read',
	FAILED: 'Not delivered',
};

function Check({ double }) {
	return (
		<Box as="svg" viewBox="0 0 16 11" w="16px" h="11px" display="block" aria-hidden="true">
			{double ? (
				<>
					<path d="M1 6l3.4 3.4L10.4 3" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
					<path d="M5.6 6l3.4 3.4L15 3" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
				</>
			) : (
				<path d="M2.5 6l3.6 3.6L13.5 2.6" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
			)}
		</Box>
	);
}

export default function Ticks({ status }) {
	const label = LABEL[status] ?? LABEL.PENDING_UNKNOWN;

	if (status === 'PENDING' || status === 'PENDING_UNKNOWN' || !status) {
		return <Icon as={FiClock} boxSize="3" color="wa.inkMuted" aria-label={label} title={label} ml="1" />;
	}
	if (status === 'FAILED') {
		return <Icon as={FiAlertCircle} boxSize="3" color="danger" aria-label={label} title={label} ml="1" />;
	}

	const double = status === 'DELIVERED' || status === 'READ';
	return (
		<Box
			ml="1"
			color={status === 'READ' ? 'wa.tickRead' : 'wa.inkMuted'}
			role="img"
			aria-label={label}
			title={label}
			transition="color 200ms ease"
		>
			<Check double={double} />
		</Box>
	);
}
